export default "__VITE_ASSET__D1l7LmYh__"